import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import EventDetail from './eventDetails';

const styleEventTitle = {
    'background-color': '#cc0033',
    'margin-top': '3px',
    height: '30px',
    display: 'flex',
    'border-radius': '15px',
    "padding-left": "5px"
};
const styleTitle = { 'margin-left': '10px', color: '#FFF', 'font-weight': '500' };
const CoursBar = (props) => {
    const [styleState, setStyleState] = useState({
        onOfmenu: 'dashboard__btn-chevron rotate-180',
        onOfopacity: 'dashboard__submenu',
        onOfmenu2: 'dashboard__btn-chevron ',
        onOfopacity2: 'dashboard__submenu max-height-0 opacity-0',
    });
    const [isExpand, setExpand] = useState(false);

    function expandManuItem() {
        if (isExpand) {
            setExpand(false);
            props.onSelect(false);
        } else {
            setExpand(true);
            props.onSelect(true);
        }
    }

    return (
        <>
            <div className="eventTitle" style={styleEventTitle}>
                <svg
                    className={isExpand ? styleState.onOfmenu : styleState.onOfmenu2}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                        expandManuItem();
                    }}
                >
                    <path
                        d="M6 9L12 15L18 9"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        stroke="#FFF"
                    />
                </svg>
                <p style={styleTitle}>{props.name}</p>
            </div>
        </>
    );
};

export default CoursBar;
